import { combineReducers } from 'redux';

import apiError from './apiError';
import byId from './byId';
import isLoading from './isLoading';
import serviceHeaders from './serviceHeaders';

export default combineReducers({
  byId,
  isLoading,
  apiError,
  serviceHeaders,
});
